function copy_field_value(el) {
    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
        var oldContentEditable = el.contentEditable,
            oldReadOnly = el.readOnly,
            range = document.createRange();

        el.contentEditable = true;
        el.readOnly = false;
        range.selectNodeContents(el);

        var s = window.getSelection();
        s.removeAllRanges();
        s.addRange(range);

        el.setSelectionRange(0, 9999);

        el.contentEditable = oldContentEditable;
        el.readOnly = oldReadOnly;

    } else {
        el.select();
    }

    try {
        document.execCommand("copy");
        return true;
    } catch(err) {
        console.log('Unable to copy...');
        return false;
    }
}

$(function() {

    //Copy share link
    $body.on('click', '.share-copy', function(e) {
        var el = document.getElementById("share_url");
        copy_field_value(el);
    });

    //Copy share link
    $body.on('click', '#share_url', function(e) {
        $(this)[0].select();
    });

});
